import { portalApplicationsApi } from './portal/portal-applications-api';
import { portalApplicationSettingsApi } from './portal/portal-application-settings-api';
import { portalApplicationTargetSettingsApi } from './portal/portal-application-target-settings-api';
import { portalAssetsApi } from './portal/portal-assets-api';
import { portalAssetTableApi } from './portal/portal-asset-table-api';
import { portalWebpagesApi } from './portal/portal-webpages-api';
import { portalSignalsApi } from './portal/portal-signals-api';
import { portalReportsApi } from './portal/portal-reports-api';
import { portalCommentsApi } from './portal/portal-comments-api';
import { portalCredentialsApi } from './portal/portal-credentials-api';
import { portalTrackerApi } from './portal/portal-tracker-api';
import { portalTracesApi } from './portal/portal-traces-api';
import { portalChatApi } from './portal/portal-chat-api';
import { portalCoPilotSessionExportApi } from './portal/portal-co-pilot-session-export-api';
import { portalFeedbackApi } from './portal/portal-feedback-api';
import { portalInteractApi } from './portal/portal-interact-api';
import { portalMemoryApi } from './portal/portal-memory-api';
import { portalNotificationCenterApi } from './portal/portal-notification-center-api';
import { portalReassociateHarEntriesApi } from './portal/portal-reassociate-har-entries-api';
import { createFindingsApi } from './portal/portal-findings-api';

export function createPortalApi() {
  const findingsApi = createFindingsApi();

  return {
    ...portalApplicationsApi,
    ...portalApplicationSettingsApi,
    ...portalApplicationTargetSettingsApi,
    ...portalAssetsApi,
    ...portalAssetTableApi,
    ...portalReassociateHarEntriesApi,
    ...portalWebpagesApi,
    ...findingsApi,
    ...portalSignalsApi,
    ...portalReportsApi,
    ...portalCommentsApi,
    ...portalCredentialsApi,
    ...portalTrackerApi,
    ...portalTracesApi,
    ...portalChatApi,
    ...portalCoPilotSessionExportApi,
    ...portalFeedbackApi,
    ...portalInteractApi,
    ...portalMemoryApi,
    ...portalNotificationCenterApi,
  };
}
